module.exports = "/assets/4a97082609601be65ff7503b379ffcf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8M.png
// module id = 2270
// module chunks = 0